module.exports = __webpack_public_path__ + "img/gain-theory.32a8b801.png";